<template>
    <div>
        <div id='modal' class='modal' v-show='showSlippageModal' @click.self='cancelDepositSlippage'>
            <div class='modal-content window white'>
                <fieldset>
                    <div class='legend2 hoverpointer' @click='cancelDepositSlippage'>
                        [<span class='greentext'>■</span>]
                    </div>
                    <legend class='redwarning'>
                        High slippage!
                    </legend>
                    <div class='content'>
                        <p class='simple-error'>
                            High slippage warning!
                            <br>
                            Depositing will have {{ (-slippage * 100).toFixed(3) }}% slippage!
                        </p>
                    </div>
                    <div class='confirmslippage'>
                        <input id='confirmslippage' type='checkbox' v-model='confirmSlippage'>
                        <label for='confirmslippage'>Confirm {{ (-slippage * 100).toFixed(3) }}% slippage!</label>
                    </div>
                    <button @click='cancelDepositSlippage' class='canceldepositslippage'>Cancel</button>
                    <button @click='handle_add_liquidity(pendingStake)' class='buttonred' :disabled='!confirmSlippage'>
                        Deposit anyway </button>
                </fieldset>
            </div>
        </div>

        <p class='simple-error' v-show="currentPoolObj().isRiskier && currentPoolObj().riskLevel > 2">
            This is an experimental pool. Please use with caution!
        </p>
        <ren1-sunset-notice :pool="currentPoolObj()" />
        <p class='simple-error' v-show="currentPoolObj().isRiskier && currentPoolObj().riskLevel < 3">
            This is a newer asset on Curve, please exercise caution with interacting with less established assets.
        </p>
        <p class='info-message gentle-message'
            v-show="config.blockchainId === 'ethereum' && currentPoolObj().id === 'pbtc'">
            pTokens has released a new version of pBTC, and a new Curve pool for it: <a
                href="https://classic.curve.finance/factory/99">new pBTC pool</a> (<a
                href="https://medium.com/pnetwork/pbtc-v2-what-is-new-788932a97f4d" target="_blank"
                rel="noopener noreferrer">learn more</a> about the pBTC v2 migration)
        </p>
        <div class="add-liquidity">
            <fieldset class="currencies">
                <legend>Currencies:</legend>
                <ul>
                    <li v-for='(currency, i) in Object.keys(currencies)'>
                        <label :for="'currency_' + getI(i)">
                            <span class='currency_label'>
                                <img :class="{ 'token-icon': true, [currency + '-icon']: true, 'y': depositc && !isPlain }"
                                    :src='getTokenIcon(currency)'>
                                <span v-if='depositc'>{{ currentPoolObj().isFactoryOnlyPool ? currencies[currency][1] :
                                    coins[currency].symbol}}
                                    <span v-if="currentPoolObj().isLendingPool && !is_meta">
                                        (in {{ coins[Array.from(Object.keys(absolute_currencies))[i]].symbol }})
                                    </span>
                                </span>
                                <span v-if='!depositc'>{{ currentPoolObj().isFactoryOnlyPool ? currencies[currency][1] :
                                    coins[currency].symbol}}
                                </span>
                                <span @click='setMaxBalanceCoin(i)' class='maxBalanceCoin'>
                                    Max:
                                    <span
                                        v-show="!currentPoolObj().isFactoryOnlyPool && coins[currency].isSynth && maxBalanceCoin(getI(i)) != '0.00'">
                                        {{ transferableBalanceText }}/
                                    </span>
                                    <span>{{ maxBalanceCoin(getI(i)) }} </span>
                                    <span v-show="susdWaitingPeriod">
                                        <span class='tooltip'>
                                            <img src='@/assets/clock-regular.svg' class='icon small'>
                                            <span class='tooltiptext normalFont'>
                                                Cannot transfer during waiting period.
                                                {{ (susdWaitingPeriodTime).toFixed(0) }} secs left.
                                            </span>
                                        </span>
                                    </span>
                                    <span
                                        v-show="!currentPoolObj().isFactoryOnlyPool && coins[currency].isSynth && maxBalanceCoin(getI(i)) != '0.00'"
                                        class='tooltip'> [?]
                                        <span class='tooltiptext long normalFont'>
                                            Max transferrable amount is {{ transferableBalanceText }}. You can free the
                                            remaining balance by settling.
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </label>
                        <input type="number" :id="'currency_' + getI(i)" :disabled='disabled' name="from_cur"
                            v-model='inputs[getI(i)]' :style="{ backgroundColor: bgColors[getI(i)] }"
                            @input='change_currency(getI(i), true)'>

                    </li>
                </ul>
            </fieldset>
            <ul>
                <gas-price></gas-price>

                <li>
                    <input id="sync-balances" type="checkbox" name="sync-balances"
                        @change='handle_sync_balances_proportion' :disabled='disabledButtons' checked
                        v-model='sync_balances'>
                    <label for="sync-balances">Add all coins in a balanced proportion</label>
                </li>
                <li>
                    <input id="max-balances" type="checkbox" name="max-balances" @change='handle_sync_balances'
                        :disabled='disabledButtons' checked v-model='max_balances'>
                    <label for="max-balances">Use maximum amount of coins available</label>
                </li>
                <!-- <li>
                    <input id="inf-approval" type="checkbox" name="inf-approval" checked v-model='inf_approval'>
                    <label for="inf-approval">Infinite approval - trust this contract forever
                    	<span class='tooltip'>[?]
                    		<span class='tooltiptext long'>
                    			Preapprove the contract to be able to spend any amount of your coins. You will not need to approve again.
                    		</span>
                    	</span>
                    </label>
                </li> -->
                <li
                    v-if="(currentPoolObj().isLendingPool || currentPoolObj().isMetaPool) && !currentPoolObj().isFactoryOnlyPool">
                    <input id="depositc" type="checkbox" name="depositc" checked v-model='depositc'>
                    <label for="depositc">{{ depositSentence }}</label>
                </li>
                <li v-if="currentPoolObj().allowTradingEth">
                    <input id='swapWrappedEth' type='checkbox' name='swapWrappedEth' v-model='swapWrappedEth'>
                    <label for='swapWrappedEth'>Deposit Wrapped {{ config.nativeCurrency.symbol }}</label>
                </li>
            </ul>
            <div class='simple-error pulse' v-show="susdWaitingPeriod">
                Cannot transfer {{ waitingAsset }} during waiting period.
                {{ (susdWaitingPeriodTime).toFixed(0) }} secs left.
            </div>
            <!-- <p class='simple-error synthsDisabled' v-show="['susdv2', 'sbtc'].includes(currentPool)">
                Deposits may be <b>temporarily</b> disabled due to <a href='https://blog.synthetix.io/the-fomalhaut-release/' rel='noopener noreferrer'>Syntetix contract upgrades</a>. Will be enabled back shortly.
            </p> -->
            <p class='simple-error' v-show="currentPool == 'linkusd'">
                This is an experimental pool. Please use with caution!
            </p>
            <p style="text-align: center" class='buttons'>
                <button id="add-liquidity"
                    :disabled="currentPool == 'susdv2' && slippage < -0.03 || depositingZeroWarning || isZeroSlippage || currentPool == 'linkusd' && slippage < -0.005"
                    @click='justDeposit = true; check_handle_add_liquidity()'>
                    Deposit <span class='loading line' v-show='loadingAction == 1'></span>
                </button>
                <button id='add-liquidity-stake'
                    :disabled="currentPool == 'susdv2' && slippage < -0.03 || depositingZeroWarning || isZeroSlippage || currentPool == 'linkusd' && slippage < -0.005"
                    v-show="hasGauge && currentPool !== 'atricrypto' && currentPool !== 'atricrypto2' && currentPool !== 'atricrypto3'"
                    @click='justDeposit = false; deposit_stake()'>
                    Deposit & stake in gauge <span class='loading line' v-show='loadingAction == 2'></span>
                </button>
                <button id='stakeunstaked' v-show="totalShare > 0 && hasGauge" :disabled='stakePercentageInvalid'
                    @click='stakeTokens()'>
                    Stake unstaked in gauge <span class='loading line' v-show='loadingAction == 3'></span>
                </button>
                <Slippage :isDeposit="true" :priceOracle="priceOracle"></Slippage>
            <p class='info-message gentle-message' v-if="lpCrvReceived !== false && lpCrvReceived > 0">
                <span v-if="currentPoolObj().cryptoPool">You'll be exposed to these {{ currentPoolObj().coins.length }}
                    assets and their individual price variations: {{currentPoolObj().coins.map(({ symbol }) =>
                    symbol).join(', ')}}.<br /><br /></span>
                You'll receive minimum {{ lpCrvReceivedText }} Curve {{ currentPool }} LP tokens <sub>{{ ((1 -
                    getMaxSlippage) * 100).toFixed(2)}}% max slippage</sub>

                <span class='curvelpusd' v-if="!currentPoolObj().cryptoPool">
                    1 Curve {{ currentPool }} LP token = {{ (1 * virtual_price).toFixed(6) }}
                    {{ assetType.toUpperCase() }}
                </span>
            </p>
            <p class="simple-error" v-if="lpCrvReceived === false">
                Error estimating this transaction’s output, please try different amounts
            </p>
            <high-usd-slippage-notice :slippage="effectiveMaxSlippage" :amount="estLpCrvReceived"
                :address="currentPoolObj().addresses.lpToken" />
            <div v-show='hasGauge'>
                <button class='simplebutton advancedoptions' @click='showadvancedoptions = !showadvancedoptions'>
                    Advanced options
                    <span v-show='!showadvancedoptions'>▼</span>
                    <span v-show='showadvancedoptions'>▲</span>
                </button>
                <div v-show='showadvancedoptions'>
                    <fieldset>
                        <legend>Advanced options:</legend>
                        <div v-show="totalShare > 0">
                            <label for='stakepercentage'>Stake %</label>
                            <input id='stakepercentage' v-model='stakepercentage'
                                :class="{ 'invalid': stakePercentageInvalid }">
                            <button id='stakeunstaked' v-show="totalShare > 0" :disabled='stakePercentageInvalid'
                                @click='stakeTokens()'>
                                Stake unstaked <span class='loading line' v-show='loadingAction == 3'></span>
                            </button>
                        </div>

                        <div id='max_slippage'>
                            <span class='tooltip'>
                                Max slippage:
                                <span class='tooltiptext long'>
                                    Customize the maximum slippage you can get when depositing
                                </span>
                            </span>
                            <input id="slippage01" type="radio" :checked="customSlippageDisabled && maxSlippage === 0.1"
                                @click='maxSlippage = 0.1; customSlippageDisabled = true'>
                            <label for="slippage01">0.1%</label>

                            <input id="slippage1" type="radio" :checked="customSlippageDisabled && maxSlippage === 0.5"
                                @click='maxSlippage = 0.5; customSlippageDisabled = true'>
                            <label for="slippage1">0.5%</label>

                            <input id="custom_slippage" type="radio" :checked="!customSlippageDisabled"
                                @click='customippageDisabled = false'>
                            <label for="custom_slippage" @click='customSlippageDisabled = false'>
                                <input type="text" id="custom_slippage_input" :disabled='customSlippageDisabled'
                                    :class="{ 'invalid': warningInputSlippage }" name="custom_slippage_input"
                                    v-model='maxInputSlippage'> %
                            </label>

                            <div class='simple-error' v-show='warningInputSlippage'>
                                {{ maxInputSlippage }}% is too low of a slippage - your transaction may fail
                            </div>
                        </div>
                    </fieldset>
                </div>

            </div>
            <p class='trade-buttons'
                v-show="currentPoolObj().coins && currentPoolObj().coins.some(({ id }) => id === 'renbtc')">
                <a href='https://bridge.renproject.io/'>Mint/redeem renBTC</a>
            </p>
            <p class='trade-buttons'
                v-show="currentPoolObj().coins && currentPoolObj().coins.some(({ id }) => id === 'tbtc')">
                <a href='https://dapp.tbtc.network/'>Mint/redeem tBTC</a>
            </p>
            <!-- <div id='mintr' v-show="currentPoolObj().containsSynthCoin">
                    <a href = 'https://mintr.synthetix.io/' target='_blank' rel="noopener noreferrer">Manage staking in Mintr</a>
                </div> -->
            <!-- <div id='mintr' v-show="['y', 'iearn'].includes(currentPool)">
                    <a href = 'https://ygov.finance/' target='_blank' rel="noopener noreferrer">Manage staking in yGov</a>
                </div> -->
            <button id="migrate-new" @click='handle_migrate_new'
                v-show="currentPool == 'compound' && oldBalance > 0">Migrate from old</button>
            <div class='info-message gentle-message' v-show='show_loading'>
                <span v-html='waitingMessage'></span> <span class='loading line'></span>
            </div>
            <div class='simple-error'
                v-if='currentPoolObj().isFactoryOnlyPool && currentPoolObj().factoryVersion === 2 && isEmptyPool()'>
                <span>This pool is still empty. It needs to be seeded with an initial deposit in order to enable
                    swaps.<br />
                    Assuming an exchange rate of 1:1, this pool should be seeded with {{currentPoolObj().coins.map(({
                        symbol }) => `${Math.trunc(1 / currentPoolObj().coins.length * 100)}% ${symbol}`).join(',
                    ')}}.<br />
                    <span v-if="currentPoolObj().cryptoPool">
                        Initial rate: {{ currentPoolObj().priceOracle }} {{ currentPoolObj().coins[0].symbol }} = 1
                        {{ currentPoolObj().coins[1].symbol }}
                    </span>
                </span>
            </div>
            <div class='info-message gentle-message' v-show='estimateGas'>
                Estimated tx cost: ${{ (estimateGas * gasPrice / 1e9 * ethPrice).toFixed(config.display.txCostPrecision)
                }}
            </div>
            <!-- <div class='simple-error' v-show="justDeposit && ['susdv2','sbtc','y','iearn'].includes(currentPool)">
                    Your tokens are being deposited into the {{ ['y', 'iearn'].includes(currentPool) ? 'y' : 'susd'}} pool without staking.
                    You can do that manually later on here or on
                    <a href = 'https://mintr.synthetix.io/' v-show="['susdv2', 'sbtc'].includes(currentPool)" target='_blank' rel="noopener noreferrer"> Mintr. </a>
                    <a href = 'https://ygov.finance/' v-show="['y', 'iearn'].includes(currentPool)" target='_blank' rel="noopener noreferrer"> yGov. </a>
                </div> -->
            <div class='simple-error' v-show='errorEstimating'>
                Error estimating gas, your transaction may fail
            </div>

            <div class='simple-error' v-show='errorStaking'>
                There was an error in staking your tokens. You can manually stake them on
                <a href='https://mintr.synthetix.io/' v-show="currentPoolObj().containsSynthCoin" target='_blank'
                    rel="noopener noreferrer"> Mintr. </a>
                <a href='https://ygov.finance/' v-show="['y', 'iearn'].includes(currentPool)" target='_blank'
                    rel="noopener noreferrer"> yGov. </a>
            </div>
            <div class='simple-error pulse' v-show='compareInputsWarning.length && !max_balances'>
                Not enough balance for currencies {{ compareInputsWarning.toString() }}
                <p v-show='compareInputsWarning.length == N_COINS - 1'>
                    Maybe you forgot to uncheck the first
                    "Add all coins in a balanced proportion" checkbox?
                </p>
            </div>
            <div class='simple-error pulse' v-show='depositingZeroWarning && !max_balances'>
                You're depositing 0 coins.
                <p>
                    Maybe you forgot to uncheck the first
                    "Add all coins in a balanced proportion" checkbox?
                </p>
            </div>
            <p class='info-message gentle-message risks'>
                <router-link to="risks">Risks of using {{ currentPool }} pool</router-link>
            </p>
            </p>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import config from '@/constants/config'
import { isFactoryPoolDataLoaded, getById } from '@/constants/pools'
import coins from '@/constants/coins'
import { notify, notifyHandler, notifyNotification } from '../../init'
import * as common from '../../utils/common.js'
import { getters, contract as currentContract, gas as contractGas, isContractDataLoaded } from '../../contract'
import { contractAbis, isFactoryAbiDataLoaded } from '@/constants/abis'
const compound = contractAbis.compound
import * as helpers from '../../utils/helpers'
import { callMethod, sendSafe } from '@/utils/Calls'
import { truncWithoutRounding } from '@/utils/Number'
import { sum, flattenArray } from '@/utils/Array'
import { sleepUntil } from '@/utils/Async'
import REFERENCE_ASSETS from '@/constants/reference-assets.js'

import * as gasPriceStore from '../common/gasPriceStore'
import GasPrice from '../common/GasPrice.vue'
import HighUsdSlippageNotice from '@/components/common/HighUsdSlippageNotice'
import Ren1SunsetNotice from '@/components/common/Ren1SunsetNotice'

import * as errorStore from '../common/errorStore'

import BN from 'bignumber.js'

import Slippage from '../common/Slippage.vue'
const allCoins = coins;

export default {
    components: {
        Slippage,
        GasPrice,
        HighUsdSlippageNotice,
        Ren1SunsetNotice,
    },
    data: () => ({
        config,
        coins,
        disabled: false,
        disabledButtons: true,
        sync_balances: false,
        errorEstimating: null,
        max_balances: true,
        inf_approval: true,
        wallet_balances: [],
        transferableBalance: null,
        susdWaitingPeriod: false,
        susdWaitingPeriodTime: 0,
        waitingAsset: 'sBTC',
        balances: [],
        inputs: [],
        amounts: [],
        bgColors: [],
        depositc: false,
        coinsContractsArray: [],
        rates: [],
        swap_address: currentContract.swap_address,
        lpCrvReceived: null,
        estLpCrvReceived: null,
        show_loading: false,
        waitingMessage: '',
        estimateGas: 0,
        ethPrice: 0,
        justDeposit: false,
        stakepercentage: 100,
        get showadvancedoptions() {
            return localStorage.getItem('advancedoptions') === 'true'
        },
        set showadvancedoptions(val) {
            localStorage.setItem('advancedoptions', val)
        },
        maxSlippage: (getById(currentContract.currentContract).cryptoPool ? 0.5 : 0.1),
        maxInputSlippage: '',
        customSlippageDisabled: true,
        loadingAction: false,
        errorStaking: false,
        slippagePromise: helpers.makeCancelable(Promise.resolve()),

        hasRewards: true,

        showSlippageModal: false,
        confirmSlippage: false,
        pendingStake: false,
        swapWrappedEth: false,
    }),
    async created() {
        this.$watch(() => currentContract.default_account, (val, oldval) => {
            if (!val || !oldval) return;
            if (val.toLowerCase() == oldval.toLowerCase()) return;
            this.mounted();
        })
        this.$watch(() => currentContract.initializedContracts, val => {
            if (val) this.mounted();
        })
        this.$watch(() => currentContract.currentContract, (val, oldval) => {
            this.setInputStyles(false, val, oldval)
            if (currentContract.initializedContracts) this.mounted();
        })

    },
    watch: {
        async depositc(val, oldval) {
            this.changeSwapInfo(val)
            await this.handle_sync_balances()
            !this.max_balances && this.highlightAllInputs();
            //await Promise.all([...Array(currentContract.N_COINS).keys()].map(i=>this.change_currency(i, false)))
            await this.calcSlippage()
        },
        async swapWrappedEth(val, oldval) {
            this.changeSwapInfo(val)
            await this.handle_sync_balances()
            !this.max_balances && this.highlightAllInputs();
            //await Promise.all([...Array(currentContract.N_COINS).keys()].map(i=>this.change_currency(i, false)))
            await this.calcSlippage()
        },
        getMaxSlippage() {
            this.getLPCrvReceived()
        },
    },
    computed: {
        ...getters,
        priceOracle() {
            return currentContract.priceOracle;
        },
        currencies() {
            const pool = getById(currentContract.currentContract);
            let currencies;

            if (pool.isFactoryOnlyPool) {
                const { coins, metaCoins } = pool;
                let factoryCurrencies = (!this.depositc && pool.isMetaPool) ?
                    (coins.slice(0, -1).concat(metaCoins)) :
                    coins;

                if (pool.cryptoPool && pool.allowTradingEth && !this.swapWrappedEth) {
                    factoryCurrencies = factoryCurrencies.map((coin) => (
                        coin.address.toLowerCase() === allCoins[config.nativeAssetErc20WrapperId].address.toLowerCase() ? allCoins[config.nativeAssetId] : coin
                    ))
                } else if (pool.cryptoPool && pool.allowTradingEth && this.swapWrappedEth) {
                    factoryCurrencies = factoryCurrencies.map((coin) => (
                        coin.address.toLowerCase() === allCoins[config.nativeAssetErc20WrapperId].address.toLowerCase() ? allCoins[config.nativeAssetErc20WrapperId] : coin
                    ))
                }

                currencies = factoryCurrencies.map(({ symbol }, i) => [i, symbol]);
            } else {
                if (pool.isMetaPool && !this.depositc) {
                    currencies = getters.meta_currencies();
                } else if (pool.isLendingPool && !this.depositc) {
                    currencies = getters.lending_currencies();
                } else if (pool.allowTradingEth && !this.swapWrappedEth) {
                    currencies = helpers.arrayToHashmap(
                        Array.from(Object.entries(getters.currencies())).map(([lc, uc]) => (
                            lc === config.nativeAssetErc20WrapperId ?
                                [config.nativeAssetId, coins[config.nativeAssetId].symbol] :
                                [lc, uc]
                        ))
                    )
                } else {
                    currencies = getters.currencies();
                }
            }

            return currencies;
        },
        absolute_currencies() {
            const pool = getById(currentContract.currentContract);

            if (pool.isMetaPool) return getters.meta_currencies();
            if (pool.isLendingPool) return getters.lending_currencies();
            return getters.currencies();
        },
        minAmount() {
            return getById(currentContract.currentContract).referenceAsset === REFERENCE_ASSETS.USD ?
                0.01 : 1e-8;
        },
        depositSentence() {
            const pool = getById(currentContract.currentContract);
            if (pool.containsAaveCoin && this.currentPool == 'geist') return 'Deposit gTokens'
            if (pool.containsAaveCoin) return 'Deposit aTokens'
            if (pool.containsCompoundCoin) return 'Deposit cTokens'
            return 'Deposit Wrapped'
        },
        calcFee() {
            let N_COINS = contractAbis[currentContract.currentContract].N_COINS
            return this.fee / 100 * N_COINS / (4 * (N_COINS - 1))
        },
        compareInputsWarning() {
            let currencies = []
            for (let [i, currency] of Object.keys(this.currencies).entries()) {
                let balance = this.wallet_balances[this.getI(i)]
                if (this.currentPool == 'susdv2' && i == 3) {
                    balance = this.susdWaitingPeriod ? 0 : this.transferableBalance
                }
                let diff3 = BN(BN(balance).times(this.rates[this.getI(i)])).minus(this.inputs[this.getI(i)])
                if (diff3.lt(BN(-0.01))) currencies.push(this.depositc ? this.currencies[currency] : currency.toUpperCase())
            }
            return currencies
        },
        depositingZeroWarning() {
            let N_COINS = this.N_COINS
            if (contractAbis[this.currentPool].is_meta)
                N_COINS = contractAbis[this.currentPool].meta_N
            return this.inputs.filter(v => +v == 0).length == N_COINS && !this.disabledButtons
        },
        isPlain() {
            return !this.currentPoolObj().isLendingPool && !this.currentPoolObj().isMetaPool;
        },
        assetType() {
            return this.currentPoolObj().referenceAsset.toUpperCase();
        },
        transferableBalanceText() {
            return this.toFixed((this.transferableBalance / 1e18))
        },
        virtual_price() {
            return currentContract.virtual_price
        },
        lpCrvReceivedText() {
            return this.toFixed(this.lpCrvReceived)
        },
        gasPrice() {
            return gasPriceStore.getGasFields({ forcePreEip1559: true }).gasPrice / 1e9
        },
        stakePercentageInvalid() {
            return this.stakepercentage < 0 || this.stakepercentage > 100
        },
        getMaxSlippage() {
            return (100 - this.effectiveMaxSlippage) / 100
        },
        warningInputSlippage() {
            return +this.effectiveMaxSlippage < 0.1
        },
        isZeroSlippage() {
            return this.effectiveMaxSlippage !== '' && (+this.effectiveMaxSlippage == 0 || isNaN(this.effectiveMaxSlippage))
        },
        allSwapTokens() {
            return Object.values(contractAbis).map(pool => pool.token_address)
        },
        allDepositZaps() {
            return Object.values(contractAbis).filter(pool => pool.deposit_address).map(pool => pool.deposit_address)
        },
        allGauges() {
            return Object.values(contractAbis).filter(pool => pool.gauge_address)
        },
        realAmounts() {
            if (this.is_meta && !this.depositc)
                return this.amounts.filter((_, i) => i != 1)
            if (this.is_meta && this.depositc)
                return this.amounts.filter((_, i) => i < 2)


            return this.amounts
        },
        realInputs() {
            if (this.is_meta && !this.depositc)
                return this.inputs.filter((_, i) => i != 1)
            if (this.is_meta && this.depositc)
                return this.inputs.filter((_, i) => i < 2)
            return this.inputs
        },
        effectiveMaxSlippage() {
            return (
                this.customSlippageDisabled ?
                    this.maxSlippage :
                    this.maxInputSlippage
            );
        },
    },
    mounted() {
        this.setInputStyles(true)
        if (currentContract.initializedContracts) this.mounted();
    },
    methods: {
        currentPoolObj() {
            return getById(this.currentPool);
        },
        isEmptyPool() {
            return this.currentPoolObj().coins.every(({ poolBalance }) => parseFloat(poolBalance) === 0)
        },
        async stakeTokens(tokens, deposit_and_stake = false) {
            if (this.loadingAction == 3) return;
            this.setLoadingAction(3);
            if (!tokens) {
                tokens = BN(await currentContract.swap_token.methods.balanceOf(currentContract.default_account).call());
                tokens = BN(this.stakepercentage / 100).times(tokens)
            }
            this.waitingMessage = `Please approve staking ${this.toFixed(tokens.div(BN(1e18)))} of your Curve LP tokens`
            var { dismiss } = notifyNotification(this.waitingMessage)
            await common.ensure_stake_allowance(tokens, currentContract.gaugeContract, true);
            dismiss()

            if (config.blockchainId === 'ethereum') {
                this.waitingMessage = `Please confirm stake transaction ${deposit_and_stake ? '(2/2)' : ''}`
                var { dismiss } = notifyNotification(this.waitingMessage)
                let promises = await Promise.all([helpers.getETHPrice()])
                this.ethPrice = promises[0]
                let gas = 550000
                //pools with rewards below:
                if (this.currentPoolObj().additionalRewards.length > 0) {
                    gas = 850000
                }
                if (this.currentPoolObj().additionalRewards.name === 'STKAAVE') {
                    gas = 950000
                }

                //we await for approval and try to get gas
                let estimateGas = gas;
                try {
                    estimateGas = await currentContract.gaugeContract.methods.deposit(tokens.toFixed(0, 1)).estimateGas({
                        from: currentContract.default_account,
                        gas,
                    })

                    this.estimateGas = estimateGas
                    estimateGas = (estimateGas * 1.2);
                    estimateGas = estimateGas.toFixed(0)
                    this.errorEstimating = null;

                } catch (e) {
                    this.errorEstimating = true;
                    estimateGas = gas;
                    this.estimateGas = gas
                }


                //this.estimateGas = gas


                try {
                    await (await sendSafe(currentContract.gaugeContract.methods.deposit(tokens.toFixed(0, 1)), {
                        from: currentContract.default_account,
                        gas: estimateGas,
                    })).pe
                        .once('transactionHash', hash => {
                            this.waitingMessage = `Waiting for stake transaction to confirm
                                ${deposit_and_stake ? '(2/2)' : ''}: no further action needed`
                            dismiss()
                            notifyHandler(hash)
                        })

                    currentContract.totalShare -= tokens
                    common.update_fee_info()
                }
                catch (err) {
                    console.error(err)
                    dismiss()
                    errorStore.handleError(err)
                }
                this.waitingMessage = ''
                this.show_loading = false;
            } else {
                await callMethod({
                    contract: currentContract,
                    contractName: 'gauge',
                    fromAddress: currentContract.default_account,
                    methodName: 'deposit',
                    params: [tokens.toFixed(0, 1)],
                    extraData: {
                        ethereumContractGasEstimationFallback: (
                            this.currentPoolObj().additionalRewards.length > 0 ? 700000 : 550000
                        ),
                    },
                    vueState: {
                        vueInstance: this,
                        initialWaitingMessage: `Please confirm stake transaction ${deposit_and_stake ? '(2/2)' : ''}`,
                        pendingWaitingMessage: `Waiting for stake <a href="[TX_URL]">transaction</a> to confirm ${deposit_and_stake ? '(2/2)' : ''}: no further action needed`,
                    },
                });

                common.update_fee_info();
            }
        },
        async returnEthers() {
            let provider;
            if (localStorage.getItem('selectedWallet') === 'MetaMask') {
                //breaks if no web3?
                let ethereum = window.ethereum;
                // Request account access if needed
                await ethereum.enable();
            }
        },
        async mounted(oldContract) {
            await sleepUntil(() => isFactoryPoolDataLoaded() && isFactoryAbiDataLoaded() && isContractDataLoaded());

            const pool = getById(currentContract.currentContract);

            if (!pool.isLendingPool && !pool.isMetaPool) this.depositc = true;
            else this.depositc = false;
            this.changeSwapInfo(this.depositc)
            currentContract.showSlippage = false;
            currentContract.slippage = 0;
            await this.handle_sync_balances();
            // await this.getLPCrvReceived()
            await this.calcSlippage()

            if (config.blockchainId === 'ethereum') {
                let calls = [...Array(currentContract.N_COINS).keys()].map(i => [this.coinsContractsArray[i]._address,
                this.coinsContractsArray[i].methods.allowance(currentContract.default_account || '0x0000000000000000000000000000000000000000', this.swap_address).encodeABI()])
                if (this.currentPoolObj().additionalRewards.length > 0 && this.currentPoolObj().id !== 'aave' && this.currentPoolObj().id !== 'saave' && currentContract.curveRewards !== null) {
                    calls.push([currentContract.curveRewards._address, currentContract.curveRewards.methods.periodFinish().encodeABI()])
                }


                if (this.currentPoolObj().referenceAsset === REFERENCE_ASSETS.ETH) {
                    calls = calls.slice(1)
                }

                let aggcalls = await currentContract.multicall.methods.aggregate(calls).call()
                let decoded = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex))

                if (this.currentPoolObj().referenceAsset === REFERENCE_ASSETS.ETH) {
                    decoded.unshift(currentContract.max_allowance);
                }
                //comment this out to have inf approval not default
                // if(decoded.slice(0,decoded.length-1).some(v=>BN(v).lte(currentContract.max_allowance.div(BN(2))) > 0))
                // 	this.inf_approval = false

                let now = Date.now() / 1000
                if (['susdv2', 'sbtc', 'y', 'iearn'].includes(this.currentPool) && +decoded[decoded.length - 1] < now)
                    this.hasRewards = false
            }

            this.disabledButtons = false;
        },
        getTokenIcon(token) {
            const symbol = this.currentPoolObj().isFactoryOnlyPool ?
                ((this.currencies && this.currencies[token] && this.currencies[token][1]) || '').toLowerCase() :
                token;
            const isFactoPoolV2 = (this.currentPoolObj().isFactoryOnlyPool && this.currentPoolObj().factoryVersion === 2);

            const address = (
                (isFactoPoolV2 && symbol !== config.nativeAssetId?.toLowerCase()) ?
                    this.currentPoolObj().coins.find((coin) => coin.symbol.toLowerCase() === symbol)?.address?.toLowerCase() :
                    undefined
            );

            return helpers.getTokenIcon(address || symbol);
        },
        toFixed(num, precisions = 2, round = 4) {
            const pool = getById(currentContract.currentContract);
            if (pool.cryptoPool) precisions = 8
            if (+num == 0 && pool.referenceAsset !== REFERENCE_ASSETS.USD) return '0.00'
            if (precisions == 2 && pool.referenceAsset !== REFERENCE_ASSETS.USD) precisions = 8
            let trunced = truncWithoutRounding(num, precisions)
            return isNaN(trunced) ? '0.00' : trunced
        },
        maxBalanceCoin(i) {
            return this.toFixed(this.wallet_balances[i] * this.rates[i])
        },
        setMaxBalanceCoin(realI) {
            const i = this.getI(realI);
            Vue.set(this.inputs, i, this.maxBalanceCoin(i))

            if (this.currentPoolObj().referenceAsset === REFERENCE_ASSETS.ETH) {
                if (i == 0) {
                    Vue.set(this.inputs, i, this.maxBalanceCoin(i) - 0.01)
                }
            }

            if (this.currentPool == 'susdv2' && i == 3
                || this.currentPool == 'sbtc' && i == 2
                || this.currentPool == 'tbtc' && i == 3
                || this.currentPool == 'pbtc' && i == 3
                || this.currentPool == 'bbtc' && i == 3
                || this.currentPool == 'obtc' && i == 3
                || this.currentPool == 'eurs' && i == 1
                || this.currentPool == 'eurt' && i == 1
                || this.currentPool == 'seth' && i == 1
                || this.currentPool == 'link' && i == 1) {
                let maxbalance_susd = this.susdWaitingPeriod ? 0 : BN(this.transferableBalance).times(this.rates[i]).toString()
                Vue.set(this.inputs, i, maxbalance_susd)
            }
        },
        inputsFormat(i) {
            if (this.inputs[i]) {
                return this.toFixed(+this.inputs[i])
            }
            return '0.00'
        },
        changeSwapInfo(val) {

            if (currentContract.is_meta) {
                this.coinsContractsArray = currentContract.all_coins
                this.rates = currentContract.c_rates
            }
            else if (val) {
                this.coinsContractsArray = currentContract.coins
                if (this.currentPool == 'susdv2') Vue.set(this.coinsContractsArray, 3, currentContract.underlying_coins[3])
                if (this.currentPool == 'sbtc') Vue.set(this.coinsContractsArray, 2, currentContract.underlying_coins[2])
                this.rates = currentContract.c_rates
                this.swap_address = currentContract.swap_address
            }
            else {

                this.coinsContractsArray = currentContract.underlying_coins
                this.rates = currentContract.coin_precisions.map(cp => 1 / cp)
                if (this.currentPoolObj().addresses.deposit === null) {
                    this.swap_address = currentContract.swap_address
                }
            }
        },
        setInputStyles(newInputs = false, newContract, oldContract) {
            let len = currentContract.N_COINS
            if (contractAbis[currentContract.currentContract].is_meta) {
                len = currentContract.meta_N
            }
            this.inputs = new Array(len).fill('0.00')
            this.bgColors = Array(len).fill({
                backgroundColor: '#707070',
                color: '#d0d0d0',
            })
        },
        async calcSlippage() {
            try {

                this.slippagePromise.cancel();
                this.slippagePromise = helpers.makeCancelable(common.calc_slippage(this.realInputs, true))
                await this.slippagePromise;
            }
            catch (err) {
                console.error(err)
            }
        },
        async handle_sync_balances() {
            await common.update_fee_info();
            let calls = []
            let N_COINS = currentContract.N_COINS
            if (currentContract.is_meta)
                N_COINS = contractAbis[currentContract.currentContract].meta_N

            if (currentContract.has_eth && currentContract.coins.some(({ _address }) => _address.toLowerCase() === '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')) {
                for (let i = 1; i < currentContract.N_COINS; i++) {
                    calls.push([this.coinsContractsArray[i]._address, this.coinsContractsArray[i].methods.balanceOf(currentContract.default_account || '0x0000000000000000000000000000000000000000').encodeABI()])
                    calls.push([currentContract.swap._address, currentContract.swap.methods.balances(i).encodeABI()])
                }
            } else if (getById(this.currentPool).isFakePlainPool) {

                for (let i = 0; i < currentContract.N_COINS; i++) {
                    calls.push([this.coinsContractsArray[i]._address, this.coinsContractsArray[i].methods.balanceOf(currentContract.default_account || '0x0000000000000000000000000000000000000000').encodeABI()])

                    //here cannot go to 5 cause there are only three coins (not sure why we needed balances, maybe to calculate balanced deposits?)
                    calls.push([currentContract.swap._address, currentContract.swap.methods.balances(0).encodeABI()])

                }

            } else {
                for (let i = 0; i < currentContract.N_COINS; i++) {
                    calls.push([this.coinsContractsArray[i]._address, this.coinsContractsArray[i].methods.balanceOf(currentContract.default_account || '0x0000000000000000000000000000000000000000').encodeABI()])
                    calls.push([currentContract.swap._address, currentContract.swap.methods.balances(i).encodeABI()])
                }
            }

            let coin_precisions = contractAbis[currentContract.currentContract].coin_precisions
            if (currentContract.is_meta) {
                let basepoolname = contractAbis[currentContract.currentContract].base_pool
                for (let i = 0; i < contractAbis[basepoolname].N_COINS; i++) {
                    calls.push([this.coinsContractsArray[i + 2]._address, this.coinsContractsArray[i + 2].methods.balanceOf(currentContract.default_account || '0x0000000000000000000000000000000000000000').encodeABI()])

                    calls.push([currentContract.base_swap._address, currentContract.base_swap.methods.balances(i).encodeABI()])
                }
                coin_precisions = contractAbis[currentContract.currentContract].meta_precisions
            }
            if (this.currentPool == 'susdv2' || this.currentPool == 'sbtc' || this.currentPool == 'tbtc' || this.currentPool == 'pbtc'
                || this.currentPool == 'bbtc'
                || this.currentPool == 'obtc'
                || this.currentPool == 'eurs'
                || this.currentPool == 'eurt'
                || this.currentPool == 'seth'
                || this.currentPool == 'link') {
                let idx = this.currentPool == 'susdv2' ? 3 : 2
                if (this.currentPool == 'tbtc' || this.currentPool == 'pbtc' || this.currentPool == 'bbtc' || this.currentPool == 'obtc')
                    idx = 4

                if (this.currentPool == 'seth' || this.currentPool == 'eurs' || this.currentPool == 'eurt' || this.currentPool == 'link')
                    idx = 1

                let currencyKey = '0x7355534400000000000000000000000000000000000000000000000000000000'

                if (['tbtc', 'sbtc', 'pbtc', 'bbtc', 'obtc'].includes(this.currentPool))
                    currencyKey = '0x7342544300000000000000000000000000000000000000000000000000000000'

                if (['seth'].includes(this.currentPool)) {
                    currencyKey = '0x7345544800000000000000000000000000000000000000000000000000000000'
                    this.waitingAsset = 'sETH';
                }

                if (['eurs', 'eurt'].includes(this.currentPool)) {
                    currencyKey = '0x7345555200000000000000000000000000000000000000000000000000000000'
                    this.waitingAsset = 'sEUR';
                }
                if (['link'].includes(this.currentPool)) {
                    currencyKey = '0x734c494e4b000000000000000000000000000000000000000000000000000000'
                    this.waitingAsset = 'sLINK';
                }


                calls.push([this.coinsContractsArray[idx]._address, this.coinsContractsArray[idx].methods.transferableSynths(currentContract.default_account || '0x0000000000000000000000000000000000000000').encodeABI()])
                calls.push([currentContract.snxExchanger._address,
                currentContract.snxExchanger.methods
                    .maxSecsLeftInWaitingPeriod(currentContract.default_account, currencyKey)
                    .encodeABI()])
            }


            let aggcalls = await currentContract.multicall.methods.aggregate(calls).call()
            let decoded = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex))
            let balances = decoded


            if (this.currentPool == 'susdv2'
                || this.currentPool == 'sbtc'
                || this.currentPool == 'tbtc'
                || this.currentPool == 'pbtc'
                || this.currentPool == 'bbtc'
                || this.currentPool == 'obtc'
                || this.currentPool == 'eurs'
                || this.currentPool == 'eurt'
                || this.currentPool == 'seth'
                || this.currentPool == 'link') balances = decoded.slice(0, -2)
            helpers.chunkArr(balances, 2).map((v, i) => {


                Vue.set(this.wallet_balances, i, v[0])
                if (!currentContract.default_account) Vue.set(this.wallet_balances, i, 0)
                Vue.set(this.balances, i, +v[1])
            })

            if (this.currentPoolObj().referenceAsset === REFERENCE_ASSETS.ETH) {
                let balance = await currentContract.web3.eth.getBalance(currentContract.default_account || '0x0000000000000000000000000000000000000000');
                // Vue.set(this.balances, 0, balance) // Commented out because this is probably undesirable behavior but not sure
                Vue.set(this.wallet_balances, 0, balance)
                // Vue.set(this.balances, 1, balances[0]) // Commented out because this is probably undesirable behavior but not sure
                Vue.set(this.wallet_balances, 1, balances[0])
            }

            if (this.currentPoolObj().allowTradingEth && !this.swapWrappedEth) {
                let balance = await currentContract.web3.eth.getBalance(currentContract.default_account || '0x0000000000000000000000000000000000000000');
                // Vue.set(this.balances, 2, balance) // Commented out because this is probably undesirable behavior but not sure
                Vue.set(this.wallet_balances, this.currentPoolObj().coins.findIndex(({ address }) => (
                    address.toLowerCase() === coins[config.nativeAssetErc20WrapperId].address.toLowerCase()
                )), balance)
                // Vue.set(this.balances, 1, balances[0])
                // Vue.set(this.wallet_balances, 1, balances[0])
            }



            if (this.currentPoolObj().containsSynthCoin) {
                this.transferableBalance = decoded[decoded.length - 2]
                this.susdWaitingPeriod = (+decoded[decoded.length - 1] != 0)
                this.susdWaitingPeriodTime = +decoded[decoded.length - 1]
            }

            if (this.max_balances) {

                let start = 0;
                if (this.currentPoolObj().referenceAsset === REFERENCE_ASSETS.ETH) {
                    start = 1
                    //ignore first coin for eth pools
                    Vue.set(this.inputs, 0, this.toFixed(BN(this.wallet_balances[0]).div(1e18)))
                }

                for (let i = start; i < N_COINS; i++) {

                    let amount = this.wallet_balances[i] * currentContract.c_rates[i]
                    if (!this.depositc) amount = this.wallet_balances[i] / coin_precisions[i]
                    var val = amount
                    var val = this.toFixed(amount);
                    if (val == 0) val = '0.00'
                    Vue.set(this.inputs, i, this.toFixed(val))
                    if (this.currentPool == 'susdv2' && i == 3
                        || this.currentPool == 'sbtc' && i == 2
                        || this.currentPool == 'tbtc' && i == 4
                        || this.currentPool == 'pbtc' && i == 4
                        || this.currentPool == 'bbtc' && i == 4
                        || this.currentPool == 'obtc' && i == 4
                        || this.currentPool == 'eurs' && i == 1
                        || this.currentPool == 'seth' && i == 1
                        || this.currentPool == 'link' && i == 1
                        || this.currentPool == 'eurt' && i == 1) {
                        let precisions = 2
                        if (this.currentPool == 'susdv2' && i == 3
                            || this.currentPool == 'sbtc' && i == 2
                            || this.currentPool == 'tbtc' && i == 4
                            || this.currentPool == 'pbtc' && i == 4
                            || this.currentPool == 'bbtc' && i == 4
                            || this.currentPool == 'obtc' && i == 4
                            || this.currentPool == 'eurs' && i == 1
                            || this.currentPool == 'eurt' && i == 1
                            || this.currentPool == 'seth' && i == 1
                            || this.currentPool == 'link' && i == 1) {
                            precisions = 18
                        }
                        let maxbalance_susd = this.susdWaitingPeriod ? 0 : this.transferableBalance
                        Vue.set(this.inputs, i, this.toFixed(BN(this.transferableBalance).div(1e18)))


                    }


                }
                // Calculate amounts to deposit in balanced proportion according to current pool balances for zero slippage
            } else {
                this.disabled = false; // ?

                let poolBalances = this.bal_info;
                const walletBalances = this.wallet_balances.map((bal, i) => bal / coin_precisions[i]);

                /**
                 * We're tiptoeing here, fixing a situation where meta pools, when
                 * depositing unwrapped in a balanced way, do not have access to the
                 * pool's underlying balances (and we want to deposit underlying tokens,
                 * so we need awareness of them); so we provide the expected value here,
                 * in exactly the situation we've noticed as not working; we don't take
                 * any chances trying to overhaul this thing too much, because everything
                 * is quite brittle in this codebase, so the cure could be worse than
                 * the ailment if we did.
                 */
                if (
                    this.is_meta &&
                    !this.depositc &&
                    poolBalances.length !== walletBalances.length
                ) {
                    console.log('this.currentPoolObj()', this.currentPoolObj()) // no underlyingcoins here, really??
                    poolBalances = [
                        ...this.currentPoolObj().coins.map(({ poolBalance, decimals }) => (
                            poolBalance / (decimals > 100 ? decimals : (10 ** decimals))
                        )),
                        ...this.currentPoolObj().underlyingCoins.slice(1).map(({ poolBalance, decimals }) => (
                            poolBalance / (decimals > 100 ? decimals : (10 ** decimals))
                        )),
                    ]
                }

                const poolBalancesRatios = poolBalances.map((bal) => (
                    bal / sum(poolBalances)
                ));

                // Cross factors for each wallet balance used as reference to see the
                // max that can be used according to the lowest relative wallet balance
                const requiredWalletBalancesForEachScenario = walletBalances.map((_, i) => (
                    walletBalances.map((_, j) => (
                        poolBalancesRatios[j] * walletBalances[i] / poolBalancesRatios[i]
                    ))
                ));
                const requiredWalletBalancesForEachScenarioFirstBal = requiredWalletBalancesForEachScenario.map(([a]) => a);
                const scenarioWithLowestBalances = requiredWalletBalancesForEachScenarioFirstBal.indexOf(Math.min(...requiredWalletBalancesForEachScenarioFirstBal));

                if (scenarioWithLowestBalances !== -1) {
                    requiredWalletBalancesForEachScenario[scenarioWithLowestBalances].forEach((idealBalance, i) => {
                        Vue.set(this.inputs, i, this.toFixed(idealBalance))
                    });
                } else {
                    // If balanced deposit calculation failed, set ALL fields to 0
                    // to protect users from involuntary imbalanced deposits
                    this.inputs.forEach((_, i) => {
                        Vue.set(this.inputs, i, 0);
                    });
                }
            }

            await this.calcSlippage()
        },
        async handle_sync_balances_proportion() {
            this.max_balances = false;
            await this.handle_sync_balances();
            //for(let i = 0; i < currentContract.N_COINS; i++) this.change_currency(i)
        },
        deposit_stake() {
            this.show_loading = true;
            this.check_handle_add_liquidity(true)
        },
        setLoadingAction(val) {
            this.loadingAction = val
            setTimeout(() => this.loadingAction = false, 500)
        },
        filterEvent(event) {
            return (this.allSwapTokens.map(swap_token => swap_token.toLowerCase()).find(swap_token => swap_token == event.address.toLowerCase()) !== undefined
            )
                && (event.raw ? (event.raw.topics[1] == "0x0000000000000000000000000000000000000000000000000000000000000000") : (event.topics[1] == "0x0000000000000000000000000000000000000000000000000000000000000000"))
                || (
                    this.allDepositZaps.map(deposit_zap => deposit_zap.toLowerCase()).find(deposit_zap => deposit_zap == event.address.toLowerCase()) !== undefined
                )
        },
        cancelDepositSlippage() {
            this.showSlippageModal = false
            this.confirmSlippage = false
            this.pendingStake = false
        },
        async check_handle_add_liquidity(stake = false) {
            if (this.slippage < -0.05) {
                this.pendingStake = stake
                this.showSlippageModal = true
                return;
            }
            this.handle_add_liquidity(stake)
        },
        async handle_add_liquidity(stake = false) {
            let actionType = stake == false ? 1 : 2;
            if (this.loadingAction == actionType) return;
            this.setLoadingAction(actionType)
            let promises = await Promise.all([helpers.getETHPrice()])
            this.ethPrice = promises[0]


            this.show_loading = true
            let calls = [...Array(currentContract.N_COINS).keys()].map(i => {
                if (this.currentPool == 'susdv2' && i == 3 || this.currentPool == 'sbtc' && i == 2
                    || this.currentPool == 'tbtc' && i == 4
                    || this.currentPool == 'pbtc' && i == 4
                    || this.currentPool == 'bbtc' && i == 4
                    || this.currentPool == 'obtc' && i == 4
                    || this.currentPool == 'seth' && i == 1
                    || this.currentPool == 'eurs' && i == 1
                    || this.currentPool == 'eurt' && i == 1
                    || this.currentPool == 'link' && i == 1)
                    return [this.coinsContractsArray[i]._address, this.coinsContractsArray[i].methods.transferableSynths(currentContract.default_account).encodeABI()]
                return [this.coinsContractsArray[i]._address, this.coinsContractsArray[i].methods.balanceOf(currentContract.default_account).encodeABI()]
            }
            )
            if (this.is_meta) {
                calls.push(...Array.from(Array(contractAbis[currentContract.currentContract].meta_N - currentContract.N_COINS), (_, i) => {
                    return [this.coinsContractsArray[i + 2]._address, this.coinsContractsArray[i + 2].methods.balanceOf(currentContract.default_account).encodeABI()]
                }))
            }
            let endOffset = 1
            calls.push([currentContract.swap_token._address, currentContract.swap_token.methods.totalSupply().encodeABI()])
            if (['susdv2', 'sbtc', 'tbtc', 'pbtc', 'bbtc', 'obtc', 'eurs', 'seth', 'link'].includes(this.currentPool)) {
                let currencyKey = '0x7355534400000000000000000000000000000000000000000000000000000000'

                if (['tbtc', 'sbtc', 'pbtc', 'bbtc', 'obtc'].includes(this.currentPool))
                    currencyKey = '0x7342544300000000000000000000000000000000000000000000000000000000'

                if (['seth'].includes(this.currentPool))
                    currencyKey = '0x7345544800000000000000000000000000000000000000000000000000000000'

                if (['eurs', 'eurt'].includes(this.currentPool))
                    currencyKey = '0x7345555200000000000000000000000000000000000000000000000000000000'

                if (['link'].includes(this.currentPool))
                    currencyKey = '0x734c494e4b000000000000000000000000000000000000000000000000000000'

                calls.push([
                    currentContract.snxExchanger._address,
                    currentContract.snxExchanger.methods
                        .maxSecsLeftInWaitingPeriod(currentContract.default_account, currencyKey)
                        .encodeABI()
                ])
                endOffset = 2
            }

            const swapStraightEth = this.currentPoolObj().allowTradingEth ? !this.swapWrappedEth : undefined;
            const ethCoinIndex = swapStraightEth ? this.currentPoolObj().coins.findIndex(({ address }) => (
                address.toLowerCase() === coins[config.nativeAssetErc20WrapperId].address.toLowerCase()
            )) : undefined;

            //if we are in the seth pool we remove the first call throwing an error
            if (this.currentPoolObj().referenceAsset === REFERENCE_ASSETS.ETH) {
                calls = calls.slice(1);
            } else if (swapStraightEth) {
                calls = [...calls.slice(0, ethCoinIndex), ...calls.slice(ethCoinIndex + 1)];
            }

            let aggcalls = await currentContract.multicall.methods.aggregate(calls).call()
            let decoded = aggcalls[1].map(hex => currentContract.web3.eth.abi.decodeParameter('uint256', hex))

            if (this.currentPoolObj().referenceAsset === REFERENCE_ASSETS.ETH) {
                //push balance at beginning of array for eth pools
                const ethBalance = await currentContract.web3.eth.getBalance(currentContract.default_account);
                decoded.unshift(ethBalance);
            } else if (swapStraightEth) {
                const ethBalance = await currentContract.web3.eth.getBalance(currentContract.default_account);
                decoded = [
                    ...decoded.slice(0, ethCoinIndex),
                    ethBalance,
                    ...decoded.slice(ethCoinIndex),
                ];
            }

            decoded.slice(0, decoded.length - endOffset).forEach((balance, i) => {
                let abi = contractAbis[currentContract.currentContract]
                let precisions = this.depositc ? abi.wrapped_precisions[i] : abi.coin_precisions[i]
                let bal = BN(balance)
                if (this.depositc) bal = BN(bal).times(currentContract.c_rates[i])
                else bal = BN(bal).div(precisions)
                if ((this.currentPool == 'susdv2' && i == 3 || this.currentPool == 'sbtc' && i == 2
                    || this.currentPool == 'tbtc' && i == 4
                    || this.currentPool == 'pbtc' && i == 4
                    || this.currentPool == 'bbtc' && i == 4
                    || this.currentPool == 'obtc' && i == 4
                    || this.currentPool == 'seth' && i == 1
                    || this.currentPool == 'eurs' && i == 1
                    || this.currentPool == 'eurt' && i == 1
                    || this.currentPool == 'link' && i == 1)
                    && +decoded[decoded.length - 1] != 0) bal = BN(0)
                let maxDiff = BN(bal).minus(BN(this.inputs[i]))
                if (!this.inputs[i]) {
                    return Vue.set(this.amounts, i, 0)
                }

                if (BN(bal).gt(0) && maxDiff.lt(0) && BN(maxDiff).lt(BN(this.minAmount))) {
                    if (!this.depositc) balance = BN(balance).div(precisions).div(currentContract.c_rates[i])
                    Vue.set(this.amounts, i, BN(balance).toFixed(0, 1))
                } else {
                    Vue.set(this.amounts, i, BN(this.inputs[i]).div(currentContract.c_rates[i]).toFixed(0, 1))
                }
            })
            this.amounts = this.amounts.map(v => v || 0);

            let total_supply = +decoded[decoded.length - endOffset];

            this.waitingMessage = 'Please approve spending your coins'


            let nonZeroInputs = this.inputs.filter(Number).length


            let amounts = this.inputs.map((v, i) => {

                if (!v) return 0
                let abi = contractAbis[currentContract.currentContract]
                let coin_precisions = abi.coin_precisions
                if (this.is_meta)
                    coin_precisions = abi.meta_precisions
                let maxDiff = (BN(this.wallet_balances[i]).div(coin_precisions[i])).minus(v)
                let balance = this.wallet_balances[i]
                if (this.currentPool == 'susdv2' && i == 3 || this.currentPool == 'sbtc' && i == 2 || this.currentPool == 'tbtc' && i == 4 || this.currentPool == 'pbtc' && i == 4
                    || this.currentPool == 'bbtc' && i == 4
                    || this.currentPool == 'obtc' && i == 4
                    || this.currentPool == 'eurs' && i == 1
                    || this.currentPool == 'eurt' && i == 1
                    || this.currentPool == 'seth' && i == 1
                    || this.currentPool == 'link' && i == 1) balance = this.transferableBalance
                if ((this.currentPool == 'susdv2' && i == 3 || this.currentPool == 'sbtc' && i == 2
                    || this.currentPool == 'tbtc' && i == 4
                    || this.currentPool == 'pbtc' && i == 4
                    || this.currentPool == 'bbtc' && i == 4
                    || this.currentPool == 'obtc' && i == 4
                    || this.currentPool == 'eurs' && i == 1
                    || this.currentPool == 'eurt' && i == 1
                    || this.currentPool == 'seth' && i == 1
                    || this.currentPool == 'link' && i == 1)
                    && +decoded[decoded.length - 1] != 0) balance = 0
                if (BN(balance).gt(0) && maxDiff.lt(0) && maxDiff.lt(BN(this.minAmount))) return BN(balance).toFixed(0, 1)
                return BN(v).times(coin_precisions[i]).toFixed(0, 1)

            })
            if (this.is_meta) {
                amounts = amounts.filter((_, i) => i != 1)
            } else {
                if (currentContract.N_COINS !== this.amounts.length) {
                    this.amounts.splice(currentContract.N_COINS, 10)
                    if (currentContract.N_COINS == this.amounts.length) {

                    }
                }
            }

            var token_amount = 0;
            if (total_supply > 0) {

                let token_amounts = this.amounts
                let contractKey = 'swap';
                if (this.is_meta) {
                    token_amounts = this.realAmounts
                    if (!this.depositc || (this.currentPoolObj().allowTradingEth && !this.swapWrappedEth)) {
                        token_amounts = amounts
                        contractKey = 'deposit_zap';
                    }
                }

                if (this.currentPoolObj().isFakePlainPool) {
                    contractKey = 'crypto_zap';
                }


                if (currentContract.is_factory) {
                    const isFactoCryptoMetaPool = (
                        contractAbis[currentContract.currentContract].is_meta &&
                        contractAbis[currentContract.currentContract].is_factory &&
                        contractAbis[currentContract.currentContract].pool_type === 'crypto'
                    );
                    const calcArgs = (
                        isFactoCryptoMetaPool ? [
                            currentContract.swap_address,
                            token_amounts,
                        ] : (contractAbis[currentContract.currentContract].pool_type === 'crypto') ? [
                            token_amounts
                        ] : (contractKey === 'swap') ? [
                            token_amounts,
                            true,
                        ] : [
                            currentContract.swap_address,
                            token_amounts,
                            true,
                        ]
                    );
                    token_amount = await currentContract[contractKey].methods.calc_token_amount(...calcArgs).call();
                } else {

                    if (this.currentPoolObj().isForexMetaPool || this.currentPoolObj().isPlainCryptoPool) {
                        token_amount = await currentContract[contractKey].methods.calc_token_amount(token_amounts).call();
                    } else {
                        token_amount = await currentContract[contractKey].methods.calc_token_amount(token_amounts, true).call();
                    }

                }

                token_amount = BN(token_amount).times(BN(1).minus(BN(this.calcFee)))
                token_amount = BN(token_amount).times(BN(this.getMaxSlippage)).toFixed(0, 1);

            }

            // if(this.depositc)
            // 	this.estimateGas = contractGas.deposit[this.currentPool] / 2
            // else
            // 	this.estimateGas = (contractGas.depositzap[this.currentPool].deposit(nonZeroInputs) | 0) / 1.5

            if (config.blockchainId === 'ethereum') {
                this.returnEthers();
            }

            if (this.inf_approval) {
                const swapStraightEth = this.currentPoolObj().allowTradingEth ? !this.swapWrappedEth : undefined;
                let approval = await common.ensure_allowance(this.realAmounts, !this.depositc, undefined, undefined, true, swapStraightEth)
            }

            else if (this.depositc) {
                let approval = await common.ensure_allowance(this.realAmounts, false);
            }
            else {
                let approval = await common.ensure_allowance(amounts, true)
            }
            let receipt;
            let minted = 0;

            let ethValue = 0;
            if (this.currentPoolObj().referenceAsset === REFERENCE_ASSETS.ETH) {
                ethValue = this.realAmounts[0]
            } else if (swapStraightEth) {
                ethValue = this.realAmounts[ethCoinIndex]
            }

            if (this.depositc && !this.currentPoolObj().allowTradingEth) {

                if (
                    this.currentPool == 'aave' ||
                    this.currentPool == 'ib' ||
                    this.currentPool == 'saave' ||
                    this.currentPool == 'aaveV3'
                ) {
                    receipt = await callMethod({
                        contract: currentContract,
                        contractName: 'swap',
                        fromAddress: currentContract.default_account,
                        methodName: 'add_liquidity',
                        params: [this.realAmounts, token_amount, 0],
                        extraData: {
                            ethValue,
                            ethereumContractGasEstimationFallback: contractGas.deposit[this.currentPool],
                        },
                        vueState: {
                            vueInstance: this,
                            initialWaitingMessage: 'Please confirm deposit transaction',
                            pendingWaitingMessage: `Waiting for deposit <a href="[TX_URL]">transaction</a> to confirm ${stake ? 'before staking (1/2)' : 'no further action required'}`,
                        },
                    });

                } else {


                    receipt = await callMethod({
                        contract: currentContract,
                        contractName: this.currentPoolObj().isFakePlainPool ? 'crypto_zap' : undefined,
                        fromAddress: currentContract.default_account,
                        methodName: 'add_liquidity',
                        params: [this.realAmounts, token_amount],
                        extraData: {
                            ethValue,
                            ethereumContractGasEstimationFallback: {
                                methodName: 'deposit',
                                poolId: this.currentPool,
                            },
                        },
                        vueState: {
                            vueInstance: this,
                            initialWaitingMessage: 'Please confirm deposit transaction',
                            pendingWaitingMessage: stake ?
                                `Waiting for deposit <a href="[TX_URL]">transaction</a> to confirm before staking` :
                                `Waiting for deposit <a href="[TX_URL]">transaction</a> to confirm, no further action required`,
                        },
                    });


                }
            }
            else {

                console.warn(this.inputs, 'inputs', amounts, 'uamounts',
                    this.amounts, 'amounts', currentContract.swap._address, 'swap address', currentContract.coin_precisions, 'coin precisions',
                    currentContract.c_rates, 'c rates',
                    currentContract.coins.map(c => c._address), 'coins', currentContract.underlying_coins.map(uc => uc._address), 'underlying_coins',
                    currentContract.virtual_price, 'virtual_price', token_amount, 'token_amount', Date.now())
                this.waitingMessage = 'Please confirm deposit transaction'
                await helpers.setTimeoutPromise(100)

                const isPoolWithNativeEthAndWithoutDepositZap = (
                    this.currentPoolObj().addresses.deposit === null &&
                    this.currentPoolObj().allowTradingEth
                );
                if (
                    (this.currentPoolObj().addresses.deposit === null || (this.currentPoolObj().allowTradingEth && this.swapWrappedEth)) ||
                    isPoolWithNativeEthAndWithoutDepositZap
                ) {
                    receipt = await callMethod({
                        contract: currentContract,
                        contractName: 'swap',
                        fromAddress: currentContract.default_account,
                        methodName: 'add_liquidity',
                        params: (this.currentPoolObj().allowTradingEth && this.swapWrappedEth) ?
                            [amounts, token_amount] :
                            [amounts, token_amount, 1],
                        extraData: {
                            ethValue,
                            ethereumContractGasEstimationFallback: contractGas.deposit[this.currentPool],
                        },
                        vueState: {
                            vueInstance: this,
                            initialWaitingMessage: 'Please confirm deposit transaction',
                            pendingWaitingMessage: `Waiting for deposit <a href="[TX_URL]">transaction</a> to confirm ${stake ? 'before staking (1/2)' : 'no further action required'}`,
                        },
                    });

                } else {
                    if (contractAbis[this.currentPool].is_factory) {
                        receipt = await callMethod({
                            contract: currentContract,
                            contractName: 'deposit_zap',
                            fromAddress: currentContract.default_account,
                            methodName: 'add_liquidity',
                            params: [contractAbis[this.currentPool].swap_address, amounts, token_amount],
                            extraData: {
                                ethValue: (this.currentPoolObj().allowTradingEth && !this.swapWrappedEth) ? amounts[0] : ethValue,
                                ethereumContractGasEstimationFallback: contractGas.depositzap[this.currentPool].deposit(nonZeroInputs) | 0,
                            },
                            vueState: {
                                vueInstance: this,
                                initialWaitingMessage: 'Please confirm deposit transaction',
                                pendingWaitingMessage: `Waiting for deposit <a href="[TX_URL]">transaction</a> to confirm ${stake ? 'before staking (1/2)' : 'no further action required'}`,
                            },
                        });
                    } else {
                        receipt = await callMethod({
                            contract: currentContract,
                            contractName: 'deposit_zap',
                            fromAddress: currentContract.default_account,
                            methodName: 'add_liquidity',
                            params: [amounts, token_amount],
                            extraData: {
                                ethValue: (this.currentPoolObj().allowTradingEth && !this.swapWrappedEth) ? amounts[2] : ethValue,
                                ethereumContractGasEstimationFallback: contractGas.depositzap[this.currentPool].deposit(nonZeroInputs) | 0,
                            },
                            vueState: {
                                vueInstance: this,
                                initialWaitingMessage: 'Please confirm deposit transaction',
                                pendingWaitingMessage: `Waiting for deposit <a href="[TX_URL]">transaction</a> to confirm ${stake ? 'before staking (1/2)' : 'no further action required'}`,
                            },
                        });
                    }
                }

            }
            this.waitingMessage = ''
            if (!stake) this.show_loading = false
            if (stake) {
                try {
                    minted = BN(
                        flattenArray(Object.values(receipt.events)).filter(event => this.filterEvent(event))
                            .filter(event => event.address.toLowerCase() == contractAbis[this.currentPool].token_address.toLowerCase())[0].raw.data)
                    await helpers.setTimeoutPromise(100)
                    await this.stakeTokens(minted, true)
                }
                catch (err) {
                    try {
                        minted = BN(
                            Object.values(receipt.logs).filter(event => this.filterEvent(event))
                                .filter(event => event.address.toLowerCase() == contractAbis[this.currentPool].token_address.toLowerCase())[0].data)
                        await helpers.setTimeoutPromise(100)
                        await this.stakeTokens(minted, true)
                    }
                    catch (err) {
                        console.error(err)
                        this.errorStaking = true;
                    }
                }
            }
            this.estimateGas = 0
            this.justDeposit = false

            await this.handle_sync_balances();
            common.update_fee_info();
        },
        highlightAllInputs() {
            for (let i = 0; i < currentContract.N_COINS; i++) this.highlightInputs(i)
        },
        highlightInputs(i) {
            let value = this.inputs[i]
            let balance = this.wallet_balances[i]
            if (this.currentPool == 'susdv2' && i == 3 || this.currentPool == 'sbtc' && i == 2
                || this.currentPool == 'tbtc' && i == 4
                || this.currentPool == 'pbtc' && i == 4
                || this.currentPool == 'obtc' && i == 4
                || this.currentPool == 'seth' && i == 1
                || this.currentPool == 'eurs' && i == 1
                || this.currentPool == 'eurt' && i == 1
                || this.currentPool == 'link' && i == 1) balance = this.transferableBalance
            if (value > balance * this.rates[i])
                Vue.set(this.bgColors, this.getI(i), 'red');
            else
                Vue.set(this.bgColors, this.getI(i), 'blue');
        },
        async getLPCrvReceived() {
            try {
                let inputs = this.inputs.map(v => v || 0)
                let calcContractName = this.currentPoolObj().isFakePlainPool ? 'crypto_zap' : 'swap';
                let c_rates = currentContract.c_rates
                if (contractAbis[currentContract.currentContract].is_meta && !this.depositc) {
                    calcContractName = 'deposit_zap';
                    inputs = inputs.filter((_, i) => i != 1)
                    c_rates = currentContract.c_rates.filter((_, i) => i != 1)
                }
                if (contractAbis[currentContract.currentContract].is_aave && !this.depositc) {
                    c_rates = [];
                    contractAbis[currentContract.currentContract].wrapped_precisions.map(precision => {
                        c_rates.push(1 / precision)
                    })
                }

                if (contractAbis[currentContract.currentContract].is_meta && this.depositc)
                    inputs = inputs.slice(0, 2)


                inputs = inputs.map((v, i) => BN(v).div(c_rates[i]).toFixed(0, 1))
                // console.log(this.depositc, 'this.depositc');
                // console.log(inputs, "THE INPUTS")
                // console.log(c_rates, "c_rates[i]")
                let estLpCrvReceived;
                if (contractAbis[currentContract.currentContract].is_factory) {
                    const isFactoCryptoMetaPool = (
                        contractAbis[currentContract.currentContract].is_meta &&
                        contractAbis[currentContract.currentContract].is_factory &&
                        contractAbis[currentContract.currentContract].pool_type === 'crypto'
                    );
                    const calcArgs = (
                        isFactoCryptoMetaPool ? [
                            contractAbis[currentContract.currentContract].swap_address,
                            inputs,
                        ] : (contractAbis[currentContract.currentContract].pool_type === 'crypto') ? [
                            inputs
                        ] : (calcContractName === 'swap') ? [
                            inputs,
                            true,
                        ] : [
                            contractAbis[currentContract.currentContract].swap_address,
                            inputs,
                            true,
                        ]
                    );
                    estLpCrvReceived = await currentContract[calcContractName].methods.calc_token_amount(...calcArgs).call() / 1e18
                } else {

                    if (this.currentPoolObj().isForexMetaPool || this.currentPoolObj().isPlainCryptoPool) {
                        estLpCrvReceived = await currentContract[calcContractName].methods.calc_token_amount(inputs).call() / 1e18
                    } else {
                        estLpCrvReceived = await currentContract[calcContractName].methods.calc_token_amount(inputs, true).call() / 1e18
                    }

                }

                this.estLpCrvReceived = estLpCrvReceived
                this.lpCrvReceived = estLpCrvReceived * this.getMaxSlippage
            } catch (err) {
                console.error(err);
                this.lpCrvReceived = false;
                this.estLpCrvReceived = false;
            }
        },
        async change_currency(i, setInputs = true, event) {


            if (event) {
                this.inputs[i] = event.target.value
            }
            var value = this.inputs[i]
            this.highlightInputs(i)

            let N_COINS = currentContract.N_COINS
            if (this.is_meta)
                N_COINS = contractAbis[currentContract.currentContract].meta_N


            if (this.sync_balances && !this.max_balances) {
                for (let j = 0; j < N_COINS; j++) {
                    if (j != i) {
                        var value_j = this.inputs[j]

                        if (this.balances[i] * currentContract.c_rates[i] > 1) {
                            // proportional
                            let bali = this.balances[i]
                            let balj = this.balances[j]
                            if (this.is_meta && i > 1)
                                bali *= this.bal_info[1] * 1e18 / this.base_supply
                            if (this.is_meta && j > 1)
                                balj *= this.bal_info[1] * 1e18 / this.base_supply
                            var newval = value / currentContract.c_rates[i] * balj / bali;
                            newval = Math.floor(newval * currentContract.c_rates[j] * 100) / 100;
                            setInputs && Vue.set(this.inputs, j, newval);

                        } else {
                            if (!this.isEmptyPool()) {
                                // same value as we type
                                var newval = value;
                                setInputs && Vue.set(this.inputs, j, newval);
                            }
                        }

                        // Balance not enough highlight
                        if (newval > this.wallet_balances[j] * this.rates[j])
                            Vue.set(this.bgColors, j, 'red');
                        else
                            Vue.set(this.bgColors, j, 'blue');
                    }
                }
            }
            await this.getLPCrvReceived()
            await this.calcSlippage()
        },
        handle_migrate_new() {
            common.handle_migrate_new('new')
        },
        formatDateToHuman(timestamp) {
            return helpers.formatDateToHuman(timestamp)
        },
        getI(i) {
            return this.is_meta && !this.depositc && i > 0 ? i + 1 : i
        },
    }
}

</script>

<style>
#add-liquidity {
    margin-right: 1em;
}

#mintr {
    margin-top: 1em;
    margin-left: 1em;
    text-align: center;
}

#stakeunstaked {
    margin-left: 1em;
}

.pulse {
    background: red;
    animation: pulse 1s 3;
    margin: 0;
    margin-bottom: 8px;
}

.pulseinfo {
    animation: pulse 1s 3;
}

.maxBalanceCoin {
    cursor: pointer;
}

.maxBalanceCoin:hover {
    text-decoration: underline;
}

.maxBalanceCoin>span {
    font-size: 0.7em;
}

.pulse p {
    margin-bottom: 0;
}

.currency_label {
    display: block;
    margin-bottom: 0.3em;
}

.currency_label .token-icon {
    margin-right: 0.6em;
}

.curvelpusd {
    display: inline-block;
    padding-top: 1em;
}

.advancedoptions {
    margin-top: 1em;
}

.advancedoptions+div fieldset {
    margin-top: 1em;
}

.advancedoptions+div legend {
    text-align: center;
}

#stakepercentage {
    width: 2.6em;
}

label[for='stakepercentage'] {
    margin-right: 1em;
}

#stakepercentage.invalid,
#max_slippage .invalid {
    background-color: red;
}

#max_slippage {
    margin-top: 0.4em;
}

.window .risks a,
.risks a:visited {
    color: white;
    border-bottom: 1px dashed white;
    text-decoration: none;
}

.window .risks a:hover {
    text-decoration: none;
    border-bottom-style: solid;
}

.modal-content {
    text-align: center;
    padding: 0;
    border: none;
    width: 260px;
}

.modal-content fieldset {
    color: white;
    font-weight: bolder;
    border: 6px double white;
    padding-block-start: 1em;
    padding-block-end: 1em;
}

.modal-content button {
    margin-top: 0.6em;
    padding: 0 2em;
}

.legend2 {
    position: absolute;
    top: 0;
    left: 2em;
    background: #c0c0c0;
    line-height: 1.2em;
}

.greentext {
    color: green;
}

.legend2 .greentext {
    display: inline-block;
    transform: translate3d(0, -0.1em, 10em);
}

.legend2 .greentext:hover {
    transform: none;
}

.modal-content {
    width: 500px;
}

.modal .content {
    text-align: left;
}

.redwarning {
    color: darkred;
}

.canceldepositslippage {
    margin-right: 1em;
}

.buttonred {
    background: red;
    border: 1px outset red;
}

.buttonred:hover {
    background: red;
    border: 1px outset red;
}

.confirmslippage {
    margin-top: 1em;
    color: red;
}
</style>
